import {
	Component,
	OnInit,
	Input,
	Optional,
	Inject,
	Output,
	EventEmitter,
} from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormFieldDirective } from "../form-field";
import { FormFieldType } from "../form-field.model";
import { SelectFieldOption } from "./select-field.model";

@Component({
    selector: "tc-select-form-field",
    templateUrl: "./select-form-field.component.html",
    styleUrls: ["./select-form-field.component.scss"],
    standalone: false
})
export class SelectFormFieldComponent
	extends FormFieldDirective
	implements OnInit {
	// Public Variables
	public optionExists: boolean;
	public showOptions: boolean;
	public isValid: boolean;
	public showCustom: boolean;
	public showMeasurement: boolean;
	public inputValue: string;
	public customErrorMessage: string;
	public activeOptionIndex: number;
	public defaultOption: SelectFieldOption;
	// Input Variables
	@Input() options: SelectFieldOption[];
	@Input() scroll: boolean;
	@Input() top: boolean;
	// Output Variables
	@Output() optionSelected = new EventEmitter();
	// Custom Field
	@Input() noWarp = false;
	@Input() customPlaceholder: string;
	@Input() customMeasurement: string;
	@Input() defaultValue: string;
	@Output() customEntry = new EventEmitter();
	@Input() disabled = false;
	// Setter Function
	@Input() set defaultOptionValue(val: any) {
		if (val) {
			this.optionExists = true;
			this.hasError = false;
			if (val?.Key?.toLowerCase() !== "custom") {
				this.defaultOption = val;
			} else {
				this.showCustom = true;
				if (val?.Value === "Custom") {
					this.defaultValue = "";
					this.toggleCustomMeasurement(false);
				} else {
					this.defaultValue = val.Value;
					this.toggleCustomMeasurement(true);
				}
			}
		} else {
			this.inputValue = "";
			this.toggleCustomMeasurement(false);
		}
	}

	// Constructor
	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		formGroupDirective: FormGroupDirective
	) {
		super(formGroupDirective);
	}

	ngOnInit(): void {
		this.label = this.placeholder;
		this.type = FormFieldType.SELECT;

		// Setup for a default inserted option
		if (this.defaultOption) {
			this.label = this.defaultOption.Value;
			this.optionExists = true;
			this.hasError = false;
		}
	}

	public toggleOptions(): void {
		this.showOptions = !this.showOptions;
		this.touched = true;
		// Check for an error on close via button
		if (!this.showOptions) {
			this.checkErrors(this.optionExists);
		}
	}

	public blurToggleOptions(): void {
		setTimeout(() => {
			if (this.showOptions) {
				this.showOptions = !this.showOptions;
				this.checkErrors(this.optionExists);
			}
		}, 150);
	}

	public toggleCustomMeasurement(show: boolean): void {
		console.log(this.inputValue);
		this.showMeasurement =
			this.inputValue?.length > 0 || show ? true : false;
	}

	public selectDropOption(option: SelectFieldOption): void {
		this.showCustom =
			!this.showCustom && option.Value.toLowerCase() === "custom";
		this.label = option.Value;
		this.optionExists = true;
		this.hasError = false;
		if (this.showCustom && this.inputValue?.length > 0) {
			this.checkInputText(this.inputValue);
		}
		this.control.setValue(option);
		this.optionSelected.emit(option);
		this.inputChanged();
		this.toggleOptions();
	}

	public checkInputText(event: any): void {
		this.inputValue = event?.target ? event.target.value : event;
		const regEx = /^\d+$/;
		this.isValid = regEx.test(this.inputValue);
		if (this.isValid) {
			this.customEntry.emit(this.inputValue);
		}
		this.inputChanged();
	}
}
